<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Результаты мониторинга препаратов в статистике 003sm</h5>
      </div>
      <div class="card-body">
        <form @submit.prevent="getRecords(1)">
          <div class="flex justify-content-between">
            <div class="flex flex_gap_10 flex-grow-1">
              <div class="form-group">
                <label>Поиск по препарату</label>
                <input type="text" placeholder="Препарат..." class="form-control" v-model="filter.title">
              </div>
              <div class="form-group">
                <label>Тип скрытия</label>
                <select v-model="filter.hideStatus" class="form-control">
                  <option v-for="s in hideStatuses" :value="s.id">{{ s.title }}</option>
                </select>
              </div>
              <!--            <div class="input-group flex-column">-->
              <!--              <label><input type="radio" value="-1" v-model="filter.platform"> все платформы</label>-->
              <!--              <label><input type="radio" value="1" v-model="filter.platform"> только UTEKA</label>-->
              <!--              <label><input type="radio" value="2" v-model="filter.platform"> только 003sm</label>-->
              <!--            </div>-->
            </div>
            <LoadingButton
              title="Показать"
              type="submit"
              :loading="loading.records"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => {}"
              className="btn btn-outline-success"
            />
          </div>
        </form>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading.records" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading.records">
          <table class="table table-hover table-sm mt-0">
            <thead>
            <tr>
              <th></th>
              <th>Препарат</th>
              <th>Тип</th>
              <th width="70px"></th>
              <th width="100px">спрос</th>
              <th width="100px">цена</th>
              <th width="100px">наличие</th>
              <th>комментарий</th>
              <th width="100px">создано</th>
              <th width="70px"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,i) in records" :key="r.id">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>{{ r?.service_drug?.title ?? r.id }}</td>
              <td>{{ hideStatuses[r.type_id]?.title }}</td>
              <!--              <td>{{ sourceAlias[r.type_id] ?? r.type_id }}</td>-->
              <td>
                <ScanFilters v-if="(r.service_drug?.scan_tasks ?? []).length" :records="r.service_drug.scan_tasks"/>
              </td>
              <td>{{ r.service_drug?.actual_stat?.call }}</td>
              <td>
                <div class="flex flex_gap_10 align-items-center">
                  <LoadStoreTrendData v-if="r.service_drug?.actual_stat?.price" type="price"
                                      :record="r.service_drug.actual_stat"/>
                  <span>{{ r.service_drug?.actual_stat?.price }}</span>
                </div>
              </td>
              <td>
                <div class="flex flex_gap_10 align-items-center">
                  <LoadStoreTrendData v-if="r.service_drug?.actual_stat"
                                      :trend="+r.service_drug.actual_stat.store_trend"
                                      :record="r.service_drug.actual_stat"/>
                  <span>{{ r.service_drug?.actual_stat?.stores }}</span>
                </div>
              </td>
              <td>
                <template v-if="r.type_id === 2">
                  {{ r.data?.hideReasonText }}
                </template>
                <template v-else>
                  {{ r.data?.comment }}
                </template>
              </td>
              <!--              <td>-->
              <!--                <p>{{ r.detail_record?.drug?.title ?? r.detail_record?.title }}</p>-->
              <!--                <p>{{ r.detail_record?.value ?? r.detail_record?.text_value }}</p>-->
              <!--              </td>-->
              <!--              <td>-->
              <!--                <template v-if="r.type_id === 30">-->
              <!--                  <Create003WatchTask :task="r" :onDelete="(taskId) => deleteTask(taskId)"/>-->
              <!--                </template>-->
              <!--                <template v-else>-->
              <!--                  <CreateWatchTask :task="r" :detailId="r.detail_id" :onDelete="(taskId) => deleteTask(taskId)"/>-->
              <!--                </template>-->
              <!--              </td>-->
              <!--              <td>-->
              <!--                <template v-if="r.status === 2">-->
              <!--                  <template v-if="r.type_id === 28 || r.type_id === 29">-->
              <!--                    <p>Uteka <a target="_blank" :href="r.task_data?.supplier_data?.source_url"><i-->
              <!--                      class="icon-fa icon-fa-globe"/></a></p>-->
              <!--                    <p>Цена мин: <strong>{{ r.task_data?.supplier_data?.min_price ?? 0 }} Ø-->
              <!--                      {{ r.task_data?.supplier_data?.avarage_price ?? 0 }}</strong></p>-->
              <!--                    <p>Аптек: <strong>{{ r.task_data?.supplier_data?.in_stores ?? 0 }}</strong></p>-->
              <!--                  </template>-->
              <!--                  <template v-else-if="r.type_id === 30">-->
              <!--                    <p>Цена: <strong>{{ r.task_data?.supplier_data?.price ?? 0 }}</strong></p>-->
              <!--                    <p>Наличие: <strong>{{ r.task_data?.supplier_data?.stores ?? 0 }}</strong></p>-->
              <!--                    <p>Спрос: <strong>{{ r.task_data?.supplier_data?.call ?? 0 }}</strong></p>-->
              <!--                  </template>-->
              <!--                  <template v-else>-->
              <!--                    {{ r.task_data?.supplier_data }}-->
              <!--                  </template>-->
              <!--                  <p>{{ printDate(r.updated_at) }}</p>-->
              <!--                </template>-->
              <!--              </td>-->
              <td>{{ printDate(r.created_at, 'DD.MM.YYYY') }}</td>
              <td class="text-right">
                <button @click="newTaskModal(r)" class="btn btn-default" type="button">
                  <i class="icon-fa icon-fa-edit"/>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if="paginator" class="text-right">
            <paginate
              v-model="paginator.current_page"
              :page-count="paginator.last_page"
              :page-range="10"
              :margin-pages="2"
              :click-handler="getRecords"
              :prev-text="'&laquo'"
              :next-text="'&raquo'"
              :container-class="'pagination'"
              :prev-class="'page-item'"
              :prev-link-class="'page-link'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :next-class="'page-item'"
              :next-link-class="'page-link'"
              :active-class="'active green_btn'">
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import CreateWatchTask from "@/views/statistics/components/tasksType/CreateWatchTask.vue";
import Create003WatchTask from "@/views/statistics/components/tasksType/Create003WatchTask.vue";
import ScanFilters from "@/views/statistics/components/tasksType/ScanFilters.vue";
import LoadStoreTrendData from "@/views/statistics/components/LoadStoreTrendData.vue";

export default {
  title: "Не активные препараты",
  components: {
    LoadStoreTrendData,
    ScanFilters,
    Create003WatchTask,
    CreateWatchTask,
    LoadingButton,
    Paginate,
  },
  data() {
    return {
      paginator: null,
      records: [],
      filter: {
        platform: -1,
        hideStatus: 4,
        title: '',
      },
      hideStatuses: {
        0: {id: 0, title: 'Любой тип'},
        4: {id: 4, title: 'Модерация'},
        3: {id: 3, title: 'Нет поставки'},
        2: {id: 2, title: 'Скрыт'},
        '-1': {id: -1, title: 'Черный список'},
      },
      sourceAlias: {
        28: 'uteka',
        29: 'uteka',
        30: '003sm',
      },
      loading: {
        records: false,
        showBtn: false,
      }
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async deleteTask(taskId) {
      const {data} = await api.post('/tasks/update', {
        task_id: taskId,
        type: 'reject'
      });
      if (data.success) {
        this.records = this.records.filter((r) => r.id !== taskId);
        toastr['success'](data.message ?? 'сохранено', 'Успешно');
      } else {
        toastr['warning'](data.message ?? 'ошибка сервера', 'Неуспешно')
      }
    },
    newTaskModal(record) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {
          task: {id: record.id, type_id: record.type_id},
          record: record?.service_drug?.actual_stat,
          type: 'DrugStatisticMultiTask'
        },
        // callBackAction: 'refreshMSStatList'
      })
      this.$store.dispatch("recordsList/setActiveRecord", record);
    },
    async getRecords(page = 1) {
      this.loading.records = true;
      const filter = this.filter;
      // const {data: r_data} = await api.post('/statistics/drugs/scan/list', {
      const {data: r_data} = await api.post('/statistics/drugs/hidden', {
        page,
        filter
      })
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.records = data;
      } else {
        toastr['warning'](r_data.message ?? 'ошибка сервера', 'Неуспешно')
      }
      this.loading.records = false;
    }
  }
}

</script>

<style scoped>
label {
  margin-bottom: 0;
}

.flex-grow-1 .form-group {
  min-width: 270px;
}
</style>
